import { createAPIService } from './api.service';

export const APPLICATION_ENDPOINT = (companyId, applicationId) =>
  `/locales/${companyId}/${applicationId}`;

export const TRANSLATIONS_ENDPOINT = language =>
  `${PUBLIC_ENDPOINT}/${language}.json`;
export const MAIN_ENDPOINT = '/locale/api';
export const PUBLIC_ENDPOINT = '/locales';
export const LOCALES_ENDPOINT = '/admin/locales';
export const LOCALE_ENDPOINT = id => `${LOCALES_ENDPOINT}/${id}`;

const service = createAPIService(MAIN_ENDPOINT);

// endpoints
service.getLocale = async id => (await service.get(LOCALE_ENDPOINT(id))).data;

service.getLocales = async params =>
  (await service.get(LOCALES_ENDPOINT, { params: params })).data;

service.getTranslations = async (language, params) =>
  (await service.post(TRANSLATIONS_ENDPOINT(language.toUpperCase()), params))
    .data;

service.createLocale = async locale =>
  (await service.post(LOCALES_ENDPOINT, locale)).data;

service.updateLocale = async (localeId, locale) =>
  (await service.patch(LOCALE_ENDPOINT(localeId), locale)).data;

service.deleteLocale = async localeId =>
  (await service.delete(`${LOCALES_ENDPOINT}/${localeId}`)).data;

service.uploadLocaleFile = async file => {
  const formData = new FormData();
  formData.append('file', file);
  return (await service.post(`${LOCALES_ENDPOINT}/import`, formData)).data;
};

service.getLocalesData = async params =>
  (await service.post(`${LOCALES_ENDPOINT}/export`, params)).data;

export default service;
